import "./App.css";
import { useState } from "react";

function App() {
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);

  const togglePrivacyPolicy = () => {
    setShowPrivacyPolicy(!showPrivacyPolicy);
  };

  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="A scenic view representing cannabis culture in West Virginia" 
          className="hero-image" 
        />
        <p className="eyebrow">Weed West Virginia</p>
        <h1>Your Trusted Source for Cannabis Information in West Virginia</h1>
        <p className="lede">
          Stay informed with the latest updates on cannabis policy, culture, and education.
        </p>
        <div className="value-proposition">
          <p>Explore our site to find:</p>
          <ul>
            <li>Current cannabis law and policy updates</li>
            <li>Educational resources on cannabis culture</li>
            <li>Guides to understanding legal cannabis use</li>
            <li>News on local cannabis events and initiatives</li>
          </ul>
        </div>
        <div className="cta-row">
          <a href="/updates" className="cta-button">Stay Informed</a>
        </div>
      </header>

      <footer>
        <button onClick={togglePrivacyPolicy}>Privacy Policy</button>
      </footer>

      {showPrivacyPolicy && (
        <div className="privacy-policy">
          <h2>Privacy Policy</h2>
          <p>
            At Weed West Virginia, we are committed to protecting your privacy. We collect data 
            through analytics tools and cookies to enhance your experience on our site. 
            This data helps us understand how our users interact with our content and improve 
            our services.
          </p>
          <p>
            Third-party vendors, including Google AdSense, may use cookies to serve ads based on 
            your prior visits to our site or other sites on the internet. You can learn more about 
            how Google uses your data and manage your ad settings by visiting 
            <a href="https://myaccount.google.com/data-and-privacy" target="_blank"> Google's ad settings</a>.
          </p>
          <p>
            If you have any questions about our privacy practices, please contact us at 
            <a href="mailto:info@weedwestvirginia.com"> info@weedwestvirginia.com</a>.
          </p>
        </div>
      )}
    </div>
  );
}

export default App;